import React from "react";
import Hero from "../components/Hero";
import Portfolio from "../components/Portfolio";
import useSEO from "../lib/seo";

export default function HomePage() {
  useSEO({
    title: "LNZ Designs & Development Co. Ltd | Concept to Completion · Jamaica",
    description:
      "Jamaica's integrated engineering, architecture and construction partner. Residential, commercial and infrastructure projects across the Caribbean and the UK. Founded by Dr Leighton A. Ellis, Chartered Civil Engineer.",
    path: "/",
    keywords:
      "construction Jamaica, engineering Jamaica, architecture Jamaica, civil engineering Caribbean, structural engineering, project management Jamaica, LNZ, Dr Leighton Ellis, Kingston construction",
  });
  return (
    <div data-testid="home-page">
      <Hero />
      <Portfolio
        id="projects"
        overline="FEATURED WORK"
        title="Projects that set the standard across the Caribbean."
        subtitle="A snapshot of recent engineering, construction and project management work delivered for government programmes, private developers and institutional clients."
        showFilters={false}
        showViewAll={true}
      />
    </div>
  );
}
